/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ReprocessStudentsRequestViewModel } from "../types/ReprocessStudentsRequestViewModel.ts";

export const reprocessStudentsRequestViewModelSchema = z.object({
  justInsert: z.optional(z.boolean()),
  validateAndInsert: z.optional(z.boolean()),
  validateAndRemove: z.optional(z.boolean()),
  removeStudentWithOutAttendance: z.optional(z.boolean()),
}) as unknown as ToZod<ReprocessStudentsRequestViewModel>;
